import { RiskLevel, getAgeFromDob } from '@equip.health/ui';

type NiaaaBstadJsonResults = Partial<{
  niaaa_pt_dob: string; // YYYY-MM-DD or YYYY-DD-MM?
  niaaa_pt_drinking_presence: boolean;
  niaaa_friends_drinking_presence: boolean;
  niaaa_pt_other_substances_presence: boolean;
  bstad_tobacco_use: number;
  bstad_marijuana_use: number;
  bstad_sedatives_use: number;
  bstad_medication_types: string[];
  bstad_substance_types: string[];
  bstad_amphetamines_use: number;
  bstad_number_of_drinks: number;
  crafft_use_alone: boolean;
  crafft_oui_presence: boolean;
  crafft_forget_things: boolean;
  crafft_family_friends_concern: boolean;
  crafft_use_to_relax_feel_better_fit_in: boolean;
  crafft_trouble_presence: boolean;
}>;

export const deriveNiaaaRiskLevel = (parsedJson: NiaaaBstadJsonResults) => {
  const age = getAgeFromDob(parsedJson?.niaaa_pt_dob);
  const niaaa_friends_drinking_presence =
    parsedJson?.niaaa_friends_drinking_presence;
  const niaaa_pt_drinking_presence = parsedJson?.niaaa_pt_drinking_presence;
  const niaaa_pt_other_substances_presence =
    parsedJson?.niaaa_pt_other_substances_presence;

  let niaaaRiskLevel: RiskLevel | null = null;

  if (age >= 9 && age <= 11) {
    if (
      niaaa_friends_drinking_presence === false &&
      niaaa_pt_drinking_presence === false &&
      niaaa_pt_other_substances_presence === false
    ) {
      niaaaRiskLevel = RiskLevel.LOW;
    } else if (
      niaaa_friends_drinking_presence === true &&
      niaaa_pt_drinking_presence === false &&
      niaaa_pt_other_substances_presence === false
    ) {
      niaaaRiskLevel = RiskLevel.MEDIUM;
    } else if (
      niaaa_pt_drinking_presence === true ||
      niaaa_pt_other_substances_presence === true
    ) {
      niaaaRiskLevel = RiskLevel.HIGH;
    }
  } else if (age >= 12 && age <= 17) {
    if (
      niaaa_pt_drinking_presence === false &&
      niaaa_pt_other_substances_presence === false
    ) {
      niaaaRiskLevel = RiskLevel.LOW;
    } else {
      niaaaRiskLevel = RiskLevel.HIGH;
    }
  }
  return niaaaRiskLevel;
};

export const deriveBstadRiskLevel = (parsedJson: NiaaaBstadJsonResults) => {
  const bstad_tobacco_use = parsedJson?.bstad_tobacco_use;
  const bstad_number_of_drinks = parsedJson?.bstad_number_of_drinks;
  const bstad_marijuana_use = parsedJson?.bstad_marijuana_use;
  const bstad_medication_types = parsedJson?.bstad_medication_types ?? [];
  const bstad_substance_types = parsedJson?.bstad_substance_types ?? [];

  let bstadRiskLevel: RiskLevel | null = null;
  if (
    bstad_substance_types?.length === 1 &&
    bstad_medication_types?.length === 1 &&
    bstad_substance_types[0] === 'none' &&
    bstad_medication_types[0] === 'none'
  ) {
    if (
      bstad_tobacco_use === 0 &&
      bstad_number_of_drinks === 0 &&
      bstad_marijuana_use === 0
    ) {
      bstadRiskLevel = RiskLevel.LOW;
    } else if (
      bstad_tobacco_use <= 5 ||
      bstad_number_of_drinks === 1 ||
      bstad_marijuana_use === 1
    ) {
      bstadRiskLevel = RiskLevel.MEDIUM;
    }
  } else if (
    bstad_tobacco_use > 5 ||
    bstad_number_of_drinks > 1 ||
    bstad_marijuana_use > 1 ||
    (bstad_substance_types.length > 0 && bstad_substance_types[0] !== 'none') ||
    (bstad_medication_types.length > 0 && bstad_medication_types[0] !== 'none')
  ) {
    bstadRiskLevel = RiskLevel.HIGH;
  }
  return bstadRiskLevel;
};

export const deriveCrafftRiskLevel = (parsedJson: NiaaaBstadJsonResults) => {
  const crafft_oui_presence = parsedJson?.crafft_oui_presence;
  const crafft_use_to_relax_feel_better_fit_in =
    parsedJson?.crafft_use_to_relax_feel_better_fit_in;
  const crafft_use_alone = parsedJson?.crafft_use_alone;
  const crafft_forget_things = parsedJson?.crafft_forget_things;
  const crafft_family_friends_concern =
    parsedJson?.crafft_family_friends_concern;
  const crafft_trouble_presence = parsedJson?.crafft_trouble_presence;
  let crafftRiskLevel: RiskLevel | null = null;
  const crafftResponses = [
    crafft_oui_presence,
    crafft_use_to_relax_feel_better_fit_in,
    crafft_use_alone,
    crafft_forget_things,
    crafft_family_friends_concern,
    crafft_trouble_presence,
  ];

  const trueResponsesCount = crafftResponses.filter(
    (response) => response === true,
  )?.length;
  const falseResponsesCount = crafftResponses.filter(
    (response) => response === false,
  )?.length;

  if (
    falseResponsesCount === crafftResponses?.length ||
    trueResponsesCount === 1
  ) {
    crafftRiskLevel = RiskLevel.MEDIUM;
  } else if (trueResponsesCount > 1) {
    crafftRiskLevel = RiskLevel.HIGH;
  }
  return crafftRiskLevel;
};
